<template>
    <div class="summary__assignments">
        <!-- <div class="card">
            <div class="summary__title">
                <i class="far fa-chalkboard-teacher"></i> Assignments (Queued)
            </div>
        </div> -->
        <div class="row">
            <summary-assignments-item v-for="counsellor in data" :key="counsellor.filterValue" :counsellor="counsellor">
            </summary-assignments-item>
        </div>
    </div>
</template>

<script>
import SummaryAssignmentsItem from "./AssignmentsItem";

export default {
    name: 'summary-assignments',
    components: {
        SummaryAssignmentsItem
    },
    props: {
        data: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
.summary__assignments {
    /* border: none;
    color: #595d6e;
    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px; */
}

.summary__title {
    border-bottom: 1px solid #ebedf2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    padding: 16px 20px;
}

.summary__title>i {
    color: #5d78ff;
    font-size: 1.25rem;
}
</style>